import { render } from "./CartSvg.vue?vue&type=template&id=0607f731&bindings={}"
import script from "./CartSvg.vue?vue&type=script&lang=ts"
export * from "./CartSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script